/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const knownCustomerNumberMutationResponseOutputKnownNumberIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const knownCustomerNumberMutationResponseOutputKnownNumberCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const knownCustomerNumberMutationResponseOutputKnownNumberNumberRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);
export const knownCustomerNumberMutationResponseOutputKnownNumberDisplayMax = 80;

export const knownCustomerNumberMutationResponseOutputKnownNumberCreatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const knownCustomerNumberMutationResponseOutputKnownNumberUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const knownCustomerNumberMutationResponseOutputAggregateCustomerIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const knownCustomerNumberMutationResponseOutputAggregateCustomerVersionExclusiveMin = 0;
export const knownCustomerNumberMutationResponseOutputAggregateCustomerVersionMax = 9007199254740991;

export const knownCustomerNumberMutationResponseOutputAggregateUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const KnownCustomerNumberMutationResponseOutput = zod.object({
  knownNumber: zod.object({
    id: zod.uuid().regex(knownCustomerNumberMutationResponseOutputKnownNumberIdRegExp),
    customerId: zod
      .uuid()
      .regex(knownCustomerNumberMutationResponseOutputKnownNumberCustomerIdRegExp),
    number: zod.string().regex(knownCustomerNumberMutationResponseOutputKnownNumberNumberRegExp),
    display: zod
      .string()
      .min(1)
      .max(knownCustomerNumberMutationResponseOutputKnownNumberDisplayMax),
    createdAt: zod.iso
      .datetime({ offset: true })
      .regex(knownCustomerNumberMutationResponseOutputKnownNumberCreatedAtRegExp),
    updatedAt: zod.iso
      .datetime({ offset: true })
      .regex(knownCustomerNumberMutationResponseOutputKnownNumberUpdatedAtRegExp),
  }),
  aggregate: zod.object({
    customerId: zod
      .uuid()
      .regex(knownCustomerNumberMutationResponseOutputAggregateCustomerIdRegExp),
    customerVersion: zod
      .int()
      .gt(knownCustomerNumberMutationResponseOutputAggregateCustomerVersionExclusiveMin)
      .max(knownCustomerNumberMutationResponseOutputAggregateCustomerVersionMax),
    updatedAt: zod.iso
      .datetime({ offset: true })
      .regex(knownCustomerNumberMutationResponseOutputAggregateUpdatedAtRegExp),
  }),
});

export type KnownCustomerNumberMutationResponseOutput = zod.input<
  typeof KnownCustomerNumberMutationResponseOutput
>;
export type KnownCustomerNumberMutationResponseOutputOutput = zod.output<
  typeof KnownCustomerNumberMutationResponseOutput
>;
